import { Field } from 'cccisd-formik';
import React from 'react';
import GroupSelect from '../common/filters/GroupSelect';

export default [
    {
        name: 'group',
        label: 'Select Class',
        component: props => {
            return (
                <Field name="group">
                    {({ field, form }) => <GroupSelect {...props} field={field} form={form} />}
                </Field>
            );
        },
    },
];
